/**
 * PAPPO — NoticeModal
 * Pop-up centralizado para avisos ao usuário (ex.: chat pausado / fora do
 * horário liberado pelos pais). Amigável para a criança, com um botão "OK".
 */

import { Clock } from 'lucide-react';
import styles from './NoticeModal.module.css';

interface NoticeModalProps {
  message: string;
  onClose: () => void;
}

export function NoticeModal({ message, onClose }: NoticeModalProps) {
  return (
    <div
      className={styles.overlay}
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div className={styles.card} onClick={(e) => e.stopPropagation()}>
        <div className={styles.iconWrap}>
          <Clock size={30} strokeWidth={2.2} />
        </div>
        <p className={styles.message}>{message}</p>
        <button className={styles.okBtn} onClick={onClose} autoFocus>
          OK, entendi
        </button>
      </div>
    </div>
  );
}
